const botData = [
    {
        id: 1,
        name: "CRO_USDC",
        brokerage: 0.0042,
        interval: 0.035,
        profit: 0.035,
        price: 0.1274,
        decimal: 4,
        decimal_qty: 1,
        buyQty: 1030.6535,
    },
    // {
    //     id: 2,
    //     name: "MATIC_USDC",
    //     brokerage: 0.0042,
    //     interval: 0.1,
    //     profit: 0.1,
    //     price: 0.417,
    //     decimal: 4,
    //     decimal_qty: 1,
    //     buyQty: 219.076,
    // },
    // {
    //     id: 3,
    //     name: "CRO_USDC",
    //     brokerage: 0.0035,
    //     interval: 0.02,
    //     profit: 0.02,
    //     price: 0.1298,
    //     decimal: 4,
    //     decimal_qty: 1,
    //     buyQty: 508.22,
    // },
];

export default botData;
